import React, { useContext } from "react";
import { Button, Tooltip } from "antd";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { BiUndo } from "react-icons/bi";
import { CourseContext } from "../../../../Store";
import StuViewModal from "../../../../CourseChapters/Index/Components/StuViewModal";
import useModalHandler from "../../../../../../utils/v2/useModalHandler";

export default function CourseHeader() {
    const history = useHistory();
    const stuViewModal = useModalHandler(StuViewModal, { remove: true });
    const { course } = useContext(CourseContext);

    return (
        <div className={style.root}>
            <div>
                <h1 className={style.title}>
                    <Tooltip title={course?.courseName} placement="bottom">
                        <span>{course?.courseName}</span>
                    </Tooltip>

                    <Button
                        className={style.back}
                        onClick={() => history.goBack()}>
                        <BiUndo size={16} /> 返回
                    </Button>
                </h1>
                <p className={style.tips}>
                    课程编号: {course?.courseNo} 课序号:
                    {course?.courseSeq}
                </p>
            </div>
            <div>
                <Button
                    type="link"
                    className={style.btn}
                    onClick={stuViewModal.open}>
                    <img
                        src={require("./img/icon1.png")}
                        alt=""
                        title="学生视角查看"
                    />
                    <p>学生视角查看</p>
                </Button>
            </div>
            {stuViewModal.render(<StuViewModal width={1000} centered />)}
        </div>
    );
}
